import { SvgIcon, type SvgIconProps } from './svgIcon'

export const WithdrawIcon = ({
  width = 18,
  height = 20,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 18 20" {...props}>
    <path
      d="M14 13L9 18M9 18L4 13M9 18L9 5M4 7H1V1.5H17V7H14"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </SvgIcon>
)
